/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */
export enum PaymentStatus {
  READY = <any>'ready',
  PENDING = <any>'pending',
  INVOICED = <any>'invoiced',
  INVOICE_REJECTED = <any>'invoice-rejected',
  FUNDED = <any>'funded',
  PAY_SENT = <any>'pay-sent',
  PAY_REJECTED = <any>'pay-rejected',
  REQUESTED = <any>'requested',
  ERROR = <any>'error',
  REQUEST_REJECTED = <any>'request-rejected',
  RESENT_REQUEST = <any>'resent-request',
  PAID_DIRECT = <any>'paid-direct',
  CANCELLED = <any>'cancelled'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/payment-status.enum.ts